import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';
import { HttpClient } from '@angular/common/http';

// Tikis.
import { Api } from '../common/constants/api';
import { ServerResponse } from '../models/RES/serverResponse';
import { InitNewService } from '../models/REQ/initNewService';
import { PersonGeneralInfo } from '../models/REQ/personGeneralInfo';

@Injectable({
    providedIn: 'root'
})
export class ReportsService {
  constructor(
    private _http: HttpClient
  ) {}

  url: string = Api.Reports;
  jsonHeaders = { headers: { 'Content-Type': 'application/json' } }

  DownloadFilledMVXTemplate(fromDate: Date, toDate: Date, divisions: number[]) {
    const dates = { fromDate, toDate, divisions };
    return this._http.post<ServerResponse>(`${this.url}/DownloadFilledMVXTemplate`, dates, this.jsonHeaders);
  }

  DownloadResult(dataId: number) {
    return this._http.post<ServerResponse>(`${this.url}/DownloadResult`, dataId, this.jsonHeaders);
  }
}